function statusPriority(status: string): number {
  if (status === 'active') return 0;
  if (status === 'pending_approval') return 1;
  return 2;
}

/** Ordena activa → pendiente_aprobación → resto; dentro de cada grupo, por fecha
 *  de inicio ascendente (más próxima primero). Sin fecha de inicio va al final del grupo. */
export function sortSurveysByPriority<T>(
  surveys: T[],
  getStatus: (survey: T) => string,
  getPeriodStart: (survey: T) => string | undefined,
): T[] {
  return [...surveys].sort((left, right) => {
    const priorityDiff = statusPriority(getStatus(left)) - statusPriority(getStatus(right));
    if (priorityDiff !== 0) return priorityDiff;

    const leftPeriod = getPeriodStart(left);
    const rightPeriod = getPeriodStart(right);
    if (!leftPeriod && !rightPeriod) return 0;
    if (!leftPeriod) return 1;
    if (!rightPeriod) return -1;
    return leftPeriod.localeCompare(rightPeriod);
  });
}
